import { request } from './api';
import config from '../config/index';
const _AppId = 'dealer.vr';
export default {
  shareCount (dealerId) {
    request({
      type: 'post',
      dataType: 'json',
      contentType: 'application/json;charset=UTF-8',
      url: `${config.dealerCloudArVr}/vrshop/share?_appId=${_AppId}`,
      data: JSON.stringify({ dealerId })
    });
  },
  /**
   * wiki： http://wiki.corpautohome.com/pages/viewpage.action?pageId=143203207
   * 获取展厅分享海报
   */
  getHallSharePoster (dealerId = 0, type = 1, activityType = 0, activityId = 0, giftId = 0, number = 0) {
    return request({
      type: 'get',
      url: config.shop + '/api/dealer/getHallSharePoster',
      data: {
        _appId: _AppId,
        dealerId: dealerId,
        type: type,
        activityType: activityType,
        activityId: activityId,
        giftId: giftId,
        number: number
      },
      xhrFields: { withCredentials: true },
      transformResponse: function (data) {
        if (data) {
          return { returncode: 0, message: '', result: data };
        }
        else {
          return { returncode: 1, message: '获取展厅分享海报失败', result: data };
        }
      },
    });
  },
  get3DCarSharePoster (dealerId = 0, type = 1, seriesId = 0, url = '') {
    return request({
      type: 'post',
      url: config.threeCarSharePoster + '/jxsjs/syzyjs/zxdp/dealer/hallDcPoster',
      data: {
        _appId: _AppId,
        dealerId: dealerId,
        type: type,
        seriesId: seriesId,
        url: url
      },
      xhrFields: { withCredentials: true },
      transformResponse: function (data) {
        if (data) {
          return { returncode: 0, message: '', result: data };
        } else {
          return { returncode: 1, message: '获取展厅分享海报失败', result: data };
        }
      }
    });
  }
};
